export const resources = {
  "zh-CN": {
    translation: {
      layout: {
        brand: {
          name: "流量赢行",
          english: "Traffynity",
        },
        nav: {
          home: "首页",
          systems: "服务体系",
          consulting: "战略咨询",
          contact: "联系我们",
          cta: "免费咨询",
        },
        lang: {
          zh: "中文",
          en: "EN",
        },
        serviceGroups: [
          {
            title: "增长核心",
            items: [
              { label: "训练营", path: "/courses" },
              { label: "流量运营", path: "/operations" },
              { label: "电商系统", path: "/ecommerce" },
              { label: "信任认证", path: "/certification" },
            ],
          },
          {
            title: "品牌放大",
            items: [
              { label: "IP孵化", path: "/ip-incubation" },
              { label: "立体矩阵", path: "/matrix" },
              { label: "表达架构", path: "/team-expression" },
            ],
          },
          {
            title: "传播基建",
            items: [
              { label: "权威采访", path: "/interview" },
              { label: "活动放大", path: "/activity" },
              { label: "网站开发", path: "/web-dev" },
            ],
          },
        ],
        footer: "© {{year}} Traffynity. All rights reserved.",
      },
      home: {
        hero: {
          badge: "增长结构与结果导向",
          titleLine1: "让高客单品牌",
          titleEmphasis: "稳定被搜索与被选择",
          description: "我们搭建“搜索 + 信任 + 内容矩阵”的增长结构，让咨询与成交持续发生，而不是靠爆款碰运气。",
          highlights: [
            "多平台获客入口",
            "AI/搜索可抓取结构",
            "创始人 + 团队一致表达",
            "长尾搜索持续进线",
          ],
          ctaPrimary: "预约战略咨询",
          ctaSecondary: "查看系统",
          stats: [
            { label: "交付模型", value: "五层架构" },
            { label: "分发结构", value: "多渠道分发" },
            { label: "搜索层", value: "SEO + AI" },
          ],
          imageAlt: "创始人形象",
          floatA: "品牌信任 x 搜索资产",
          floatB: "多平台一致表达",
          scrollCue: "向下探索",
        },
        architecture: {
          tag: "五层架构模型",
          title: "影响力五层架构",
          subtitle: "不是代运营，是可复用的增长结构工程。",
          items: [
            { num: "01", title: "流量结构工程", desc: "推荐 + 搜索 + AI 三层协同" },
            { num: "02", title: "信任基础设施", desc: "认证 + 采访 + 活动 + 官网沉淀" },
            { num: "03", title: "立体表达系统", desc: "创始人 + 团队 + 多语言表达网络" },
            { num: "04", title: "全维度矩阵覆盖", desc: "多平台 × 多入口 × 多族裔" },
            { num: "05", title: "长尾资产沉淀", desc: "SEO结构 + FAQ结构 + AI可引用结构" },
          ],
        },
        services: {
          tag: "我们做什么",
          title: "从结构搭建到结果交付",
          subtitle: "训练、代运营、信任基础、跨平台矩阵一体化，先搭结构，再要结果。",
          cards: [
            { title: "影响力架构训练营", description: "两套课程包，训练定位、内容、搜索与变现结构", linkText: "查看课程包" },
            { title: "流量结构运营系统", description: "代运营服务清单 + 内容产出方向", linkText: "查看代运营方案" },
            { title: "电商增长架构", description: "电商增长结构 + 直播运营托管", linkText: "查看电商方案" },
            { title: "数字信任基础设施", description: "专业号认证与账号开通支持", linkText: "查看认证服务" },
            { title: "IP孵化系统", description: "定位、内容矩阵、流量布局与变现路径", linkText: "查看IP孵化" },
            { title: "立体矩阵系统", description: "品牌号 + IP号 + 分身号矩阵搭建", linkText: "查看矩阵方案" },
            { title: "表达架构系统", description: "团队表达训练 + 代出镜服务", linkText: "查看表达方案" },
            { title: "权威影响力系统", description: "采访类视频与权威表达放大", linkText: "查看采访服务" },
            { title: "活动影响力放大系统", description: "活动视频与内容资产长期沉淀", linkText: "查看活动服务" },
            { title: "数字基础设施网站", description: "品牌/营销/电商网站一站式开发", linkText: "查看网站方案" },
          ],
        },
        proof: {
          tag: "案例证据",
          title: "结果、结构与可复用资产",
          shotPrefix: "分镜",
          scrollHint: "向下滚动切换分镜",
          dotAriaPrefix: "查看",
          items: [
            { title: "活动现场", desc: "真实公开场景背书" },
            { title: "创始人实战", desc: "镜头前真实表达能力" },
            { title: "数据证明", desc: "完播率与搜索结果表现" },
            { title: "品牌镜头", desc: "高质感视觉资产沉淀" },
          ],
        },
        clients: {
          tag: "我们与普通公司的区别",
          title: "普通营销公司做内容，我们做“搜索 + 信任 + 内容矩阵”的成交结构。",
          compareTitle: "普通公司 vs 我们",
          usLabel: "我们",
          compare: [
            { old: "普通视频公司", oldDo: "拍内容", us: "构建表达系统" },
            { old: "普通代运营", oldDo: "发视频", us: "建立结构工程" },
          ],
          fitTitle: "我们适合谁？",
          fitItems: ["高客单行业", "地产 / 金融 / 移民 / 保险", "想跨族裔扩展的人", "想长期做品牌的人", "想被AI推荐的人"],
          notFitTitle: "不适合",
          notFitItems: ["只想做短期爆款的人", "只想低成本试水的人"],
          imageAlt: "适合客户",
        },
        faq: {
          tag: "FAQ",
          title: "常见问题",
          imageAlt: "常见问题",
          notSure: "还不确定是否适合？先做一次 15 分钟适配判断。",
          cta: "预约快速判断",
          items: [
            {
              q: "你们和普通营销代运营有什么本质区别？",
              summary: "我们不是发内容，而是建立“可搜索、可信任、可复用”的获客结构。",
              details: [
                "交付对象是影响力基础设施：流量结构、信任结构、搜索结构、AI可见结构。",
                "不仅覆盖短视频平台，也覆盖官网、搜索引擎、知识问答与可引用内容层。",
                "目标不是短期爆款，而是中长期可复用、可沉淀、可放大的增长资产。",
              ],
            },
            {
              q: "大概多久能看到结果？结果怎么衡量？",
              summary: "通常 2-4 周看到结构变化，8-12 周看到更稳定的增长信号。",
              details: [
                "前期重点看结构指标：内容矩阵完整度、账号与站点协同、搜索收录与AI可见性。",
                "中期看业务指标：线索质量、咨询转化率、品牌词搜索量、内容复用效率。",
                "我们会给出阶段目标和复盘机制，不只报播放量。",
              ],
            },
            {
              q: "哪些客户最适合你们？哪些不适合？",
              summary: "适合高客单、重信任、想做长期品牌资产的团队。",
              details: [
                "适合：地产、金融、移民、保险、教育咨询、B2B专业服务等决策链较长行业。",
                "不适合：只追求低成本试水、只看短期爆款、没有持续投入意愿的项目。",
                "如果你不确定是否匹配，建议先做一次 15 分钟适配判断。",
              ],
            },
            {
              q: "你们的交付边界是什么？会做执行吗？",
              summary: "我们提供策略、结构设计、关键执行标准和阶段陪跑。",
              details: [
                "可覆盖从定位、内容结构、渠道结构到站点/搜索/AI可见性的完整方案。",
                "执行可按团队能力分层：你方主执行 + 我方督导，或联合执行。",
                "每个阶段都会明确责任边界、验收标准和节奏。",
              ],
            },
            {
              q: "预算怎么定？有没有固定报价？",
              summary: "按目标复杂度与交付范围定制，不做一刀切套餐。",
              details: [
                "报价取决于业务目标、渠道数量、内容频率、团队基础和周期要求。",
                "先做诊断再报价，避免先收钱后试错。",
                "如果预算有限，可以先从最关键的增长瓶颈模块开始。",
              ],
            },
          ],
        },
        finalCta: {
          pretitle: "为什么现在必须升级？",
          title: "未来3年，获客成本更贵，结构化增长更省钱",
          lead: "从被动等流量，转向可搜索、可推荐、可跨平台扩散的结构化获客。",
          fromTitle: "流量将越来越来自",
          fromItems: ["AI推荐", "语义搜索", "多语言入口", "跨平台扩散"],
          missingTitle: "品牌不能缺少",
          missingItems: ["结构", "长尾", "语义清晰", "多入口"],
          description: "升级不是可选项，而是竞争基础。",
          button: "预约战略会议",
        },
      },
    },
  },
  en: {
    translation: {
      layout: {
        brand: {
          name: "Traffynity",
          english: "Traffynity",
        },
        nav: {
          home: "Home",
          systems: "Services",
          consulting: "Consulting",
          contact: "Contact",
          cta: "Free Call",
        },
        lang: {
          zh: "中文",
          en: "EN",
        },
        serviceGroups: [
          {
            title: "Growth Core",
            items: [
              { label: "Camp", path: "/courses" },
              { label: "Operations", path: "/operations" },
              { label: "Ecommerce", path: "/ecommerce" },
              { label: "Trust", path: "/certification" },
            ],
          },
          {
            title: "Brand Amplify",
            items: [
              { label: "IP Incubation", path: "/ip-incubation" },
              { label: "Matrix", path: "/matrix" },
              { label: "Expression", path: "/team-expression" },
            ],
          },
          {
            title: "Distribution",
            items: [
              { label: "Interview", path: "/interview" },
              { label: "Activity", path: "/activity" },
              { label: "Web Dev", path: "/web-dev" },
            ],
          },
        ],
        footer: "© {{year}} Traffynity. All rights reserved.",
      },
      home: {
        hero: {
          badge: "Structure-driven growth",
          titleLine1: "Help high-ticket brands",
          titleEmphasis: "get found and chosen",
          description: "We build a “Search + Trust + Content Matrix” growth system that keeps qualified leads and wins coming—without gambling on viral hits.",
          highlights: [
            "Multi-platform acquisition",
            "AI/search-crawlable structure",
            "Founder + team consistency",
            "Long-tail inbound flow",
          ],
          ctaPrimary: "Book Strategy Call",
          ctaSecondary: "Explore System",
          stats: [
            { label: "Delivery", value: "5-Layer" },
            { label: "Distribution", value: "Multi-Channel" },
            { label: "Search", value: "SEO + AI" },
          ],
          imageAlt: "Founder portrait",
          floatA: "Brand Trust x Search Assets",
          floatB: "Cross-platform consistency",
          scrollCue: "Scroll Down",
        },
        architecture: {
          tag: "Core Model",
          title: "Five-Layer Influence System",
          subtitle: "Not ops. A reusable growth-structure build.",
          items: [
            { num: "01", title: "Traffic Engineering", desc: "Recommendation + Search + AI alignment" },
            { num: "02", title: "Trust Infrastructure", desc: "Certification + Interview + Website" },
            { num: "03", title: "Expression System", desc: "Founder + Team + Multilingual narrative" },
            { num: "04", title: "Matrix Coverage", desc: "Multi-platform × entrypoint × audience" },
            { num: "05", title: "Asset Compounding", desc: "SEO + FAQ + AI-citable structure" },
          ],
        },
        services: {
          tag: "Services",
          title: "From structure to measurable results",
          subtitle: "Training, managed ops, trust setup, and cross-platform matrix in one system. Build structure, then drive results.",
          cards: [
            { title: "Influence Camp", description: "Two course packages for positioning, content, search, and monetization", linkText: "View packages" },
            { title: "Traffic Ops", description: "Managed ops scope + content output types", linkText: "View ops scope" },
            { title: "Ecommerce Growth", description: "Growth architecture + livestream operations", linkText: "View ecommerce plan" },
            { title: "Digital Trust Stack", description: "Account verification and trust-sensitive onboarding", linkText: "View verification" },
            { title: "IP Incubation", description: "Positioning, content matrix, growth layout, and monetization paths", linkText: "View IP incubation" },
            { title: "Matrix System", description: "Brand + founder + avatar account matrix build", linkText: "View matrix plan" },
            { title: "Expression System", description: "Team expression training + on-camera support", linkText: "View expression plan" },
            { title: "Authority Engine", description: "Interview video service and authority amplification", linkText: "View interview service" },
            { title: "Event Amplification", description: "Event video coverage and asset repurposing", linkText: "View event service" },
            { title: "Digital Infrastructure Site", description: "Brand/marketing/ecommerce site delivery", linkText: "View website plan" },
          ],
        },
        proof: {
          tag: "Proof",
          title: "Results, structure, and reusable assets",
          shotPrefix: "Shot",
          scrollHint: "Scroll to switch scene",
          dotAriaPrefix: "View",
          items: [
            { title: "Live Event", desc: "Real public-event credibility" },
            { title: "Founder In Action", desc: "Authentic on-camera communication" },
            { title: "Data Signals", desc: "Completion and search performance" },
            { title: "Brand Visuals", desc: "Premium visual asset accumulation" },
          ],
        },
        clients: {
          tag: "Best Fit",
          title: "High-ticket, cross-platform, long-term builders",
          usLabel: "Us",
          compareTitle: "Typical Agencies vs Us",
          compare: [
            { old: "Typical video studios", oldDo: "Shoot content", us: "Build expression systems" },
            { old: "Typical ops teams", oldDo: "Post videos", us: "Engineer growth structures" },
          ],
          fitTitle: "Best fit",
          fitItems: [
            "High-ticket industries",
            "Real estate / finance / immigration / insurance",
            "Teams expanding across audiences",
            "Teams building long-term brands",
            "Teams who want AI recommendations",
          ],
          notFitTitle: "Not a fit",
          notFitItems: [
            "Chasing short-term viral hits",
            "Testing with ultra-low budgets",
          ],
          imageAlt: "Ideal clients",
        },
        faq: {
          tag: "FAQ",
          title: "Common Questions",
          imageAlt: "Frequently asked questions",
          notSure: "Not sure if this is a fit? Start with a 15-minute match check.",
          cta: "Book Quick Check",
          items: [
            {
              q: "How are you different from typical marketing agencies?",
              summary: "We build a searchable, trustable, reusable acquisition structure.",
              details: [
                "Delivery targets infrastructure: traffic, trust, search, and AI visibility.",
                "We cover short video, website, search engines, Q&A, and citation-ready content.",
                "Goal is not viral spikes but reusable and compounding growth assets.",
              ],
            },
            {
              q: "How soon can we see results, and how do you measure?",
              summary: "2-4 weeks for structural change, 8-12 weeks for stable growth signals.",
              details: [
                "Early: matrix completeness, account-site synergy, indexing, and AI visibility.",
                "Mid: lead quality, conversion, branded search volume, and reuse efficiency.",
                "We run milestone reviews, not vanity-only reporting.",
              ],
            },
            {
              q: "Who is a strong fit, and who is not?",
              summary: "Best for high-ticket, trust-heavy teams building long-term brand assets.",
              details: [
                "Great fit: real estate, finance, immigration, insurance, education, B2B services.",
                "Not fit: low-budget trial only, short-term viral focus, no sustained commitment.",
                "If uncertain, do a 15-minute fit check first.",
              ],
            },
            {
              q: "What is your delivery boundary? Do you execute?",
              summary: "We provide strategy, architecture, execution standards, and phase support.",
              details: [
                "Coverage includes positioning, content/channels, site/search/AI visibility.",
                "Execution can be your team led with our guidance, or joint execution.",
                "Each phase has clear ownership, acceptance criteria, and cadence.",
              ],
            },
            {
              q: "How is pricing defined? Any fixed package?",
              summary: "Custom scope by goals and complexity, no one-size-fits-all package.",
              details: [
                "Price depends on goals, channel count, frequency, team baseline, and timeline.",
                "Diagnosis first, quote second, avoid paid trial-and-error.",
                "With limited budget, start from the most critical bottleneck module.",
              ],
            },
          ],
        },
        finalCta: {
          pretitle: "Why upgrade now",
          title: "Acquisition will get pricier. Structured growth will get cheaper.",
          lead: "Move from unstable traffic dependence to a searchable, citable, cross-platform acquisition system.",
          fromTitle: "Traffic will increasingly come from",
          fromItems: ["AI recommendations", "Semantic search", "Multilingual entry points", "Cross-platform distribution"],
          missingTitle: "Your brand must have",
          missingItems: ["Clear structure", "Long-tail assets", "Semantic clarity", "Multiple entry points"],
          description: "Upgrade is no longer optional. It is the baseline for competition.",
          button: "Book Strategy Session",
        },
      },
    },
  },
} as const;

export type AppResources = typeof resources;


